<div class="smart-replies__container">
  <div class="smart-replies__header">
    <div class="smart-replies__title">
      <h2>{{ 'NGX-MESSAGING.CHANNELS.assistant' | translate }}</h2>
    </div>
    <div class="smart-replies__close-btn">
      <mat-icon (click)="closeSmartReplies()" svgIcon="close_circle"></mat-icon>
    </div>
  </div>
  @if (!selectedChannel()?.isLoadingSmartReplies) {
  <div class="smart-replies__body">
    @for (sug of selectedChannel()?.smartReplies ?? []; track sug.text) {
    <div class="smart-replies__suggest">
      <p class="smart-replies__text" id="smart-replies-{{ $index }}" (click)="sendSuggestion(sug.text)">
        {{ sug.text }}
      </p>
    </div>
    }
  </div>
  } @else {
  <ngx-skeleton-loader
    animation="false"
    [count]="10"
    appearance="line"
    [theme]="{
      'border-radius': '5px',
      height: '80px'
    }"></ngx-skeleton-loader>
  }
</div>
